'use es6';

export const DOM_READY = 'DOM_READY';
export const IFRAME_ROOT_MOUNTED = 'IFRAME_ROOT_MOUNTED';
export const IFRAME_ROOT_LOADED = 'IFRAME_ROOT_LOADED';
export const IFRAME_ROOT_LOADING_ERROR = 'IFRAME_ROOT_LOADING_ERROR';
export const REDUX_ACTION = 'REDUX_ACTION';
export const IFRAME_REDUX_ACTION = 'IFRAME_REDUX_ACTION';
export const RELOAD_IFRAME = 'RELOAD_IFRAME';